import React, {useState} from 'react';
import {useAuthContext}  from '../../../hooks/useAuthContext'

import ForecastForm from './ForecastForm'


const Forecast = () => { 
  const [nsnData, setNsnData] = useState([]);
  const {user} = useAuthContext()

 
  return (
    
    <div className="searchPage">
      <ForecastForm setNsnData={setNsnData} />

      <h3>
        24 Month Forecast:
        {nsnData.length > 0 ? nsnData[0].json : 'No data available'}
      </h3>
      
    </div>
    
  )
         
  
}

export default Forecast;